import { render, staticRenderFns } from "./ResultWithProductPage.vue?vue&type=template&id=ccb8d2d2&scoped=true"
import script from "./ResultWithProductPage.vue?vue&type=script&lang=js"
export * from "./ResultWithProductPage.vue?vue&type=script&lang=js"
import style0 from "./ResultWithProductPage.vue?vue&type=style&index=0&id=ccb8d2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb8d2d2",
  null
  
)

export default component.exports